import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { PaymentMilestone } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type PaymentMilestoneModel = getEntityType<PaymentMilestoneState>;

export type PaymentMilestoneState = EntityState<
  Omit<RequireSome<Partial<PaymentMilestone>, 'id'>, 'organization'> & {
    organization: { id: string };
  }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'payment-milestone' })
export class PaymentMilestoneStore extends EntityStore<PaymentMilestoneState> {
  constructor() {
    super({});
  }
}
